import React from 'react';

import { Box, Container, Grid } from '@mui/material';

import { CardItem } from './card-item';
import { CardItemProps } from './type';

// ********************************************************************************
type Props = {
  items: CardItemProps[];
};
export const Cards: React.FC<Props> = ({ items }) => {
  // == Render ====================================================================
  return (
    <Box component="section" py="24px">
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid item xs={12} md={6} key={index} sx={{ padding: '0 !important' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CardItem {...item} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
